import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { arrayOf, bool, number, shape, string } = proptypes;
import {
  Checkbox,
  FormController,
  FormGroup,
  SelectionControlLabel,
  Typography
} from '@one-thd/sui-atomic-components';
import { usePartsAndServices } from '../PartsAndServicesProvider';
import { isEmptyObject, isSelected } from '../../utils';

export const HaulAwayCheckboxes = ({ haulAwayItems, lineItemId }) => {
  const {
    haulAwaySelections,
    initializeHaulAwaySelections,
    toggleHaulAwaySelection
  } = usePartsAndServices();

  useEffect(() => {
    if (isEmptyObject(haulAwaySelections)) {
      initializeHaulAwaySelections();
    }
  }, []);

  const onChange = (haulAwayItem) => {
    toggleHaulAwaySelection(lineItemId, haulAwayItem);
  };

  if (!haulAwayItems.length) return null;

  return (
    <>
      <Typography variant="body-base" weight="bold">
        Haul Away & Move
      </Typography>
      <div className="sui-mt-1">
        <FormController>
          <FormGroup gap={false} alignment="top">
            {
              haulAwayItems.map((haulAwayItem, index) => {
                const { description, price, configAttr } = haulAwayItem || {};
                return (
                  <SelectionControlLabel
                    alignment="top"
                    key={configAttr}
                    label={(
                      <span className="sui-flex sui-gap-1 sui-flex-wrap sui-mt-1">
                        <Typography component="span">{description}</Typography>
                        <Typography component="span" weight="bold">${price.toFixed(2).toString()}</Typography>
                      </span>
                    )}
                  >
                    <Checkbox
                      checked={isSelected({ selections: haulAwaySelections, lineItemId, configAttr })}
                      value={index.toString()}
                      name={description}
                      onChange={() => onChange(haulAwayItem)}
                    />
                  </SelectionControlLabel>
                );
              })
            }
          </FormGroup>
        </FormController>
      </div>
    </>
  );
};

HaulAwayCheckboxes.propTypes = {
  haulAwayItems: arrayOf(shape({
    description: string,
    installation: bool,
    price: number,
    configAttr: string,
    termLength: number,
    category: string
  })),
  lineItemId: string.isRequired
};

HaulAwayCheckboxes.defaultProps = {
  haulAwayItems: [],
};

HaulAwayCheckboxes.displayName = 'HaulAwayCheckboxes';
